// extracted by mini-css-extract-plugin
export default {"wrapper":"rangepicker_wrapper__P6vSP","pane":"rangepicker_pane__FeFKn"};